export const FormError = {
  baseStyle: {
    text: {
      color: 'product.text.state.warning',
      fontSize: 'xs',
    },
  },
}
